<template>
  <div>
    <v-data-table
        :items="measurements.data"
        :disable-initial-sort="true"
        :headers="headers"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="isLoading"
        :rows-per-page-items="[10,25,50,100]"
        :no-data-text="trans('app.search.no_data')"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{ props.item.weight }}
          </td>
          <td>
            {{ props.item.neck }}
          </td>
          <td>
            {{ props.item.arm }}
          </td>
          <td>
            {{ props.item.chest }}
          </td>
          <td>
            {{ props.item.waist }}
          </td>
          <td>
            {{ props.item.stomach }}
          </td>
          <td>
            {{ props.item.hips }}
          </td>
          <td>
            {{ props.item.thigh }}
          </td>
          <td>
            {{ props.item.calf }}
          </td>
          <td class="text-xs-center">
            {{ props.item.created_at | format_date() }}
          </td>
          <td class="justify-end layout px-0 pr-4">
            <v-layout align-center justify-end>
              <icon-button
                  :permission="hasPermission('patient_measurements_edit')"
                  icon="edit"
                  color="success"
                  cls="mr-0 ml-0"
                  :tooltip="{top: true, bottom: false, attach: false}"
                  :iconOptions="{small: true}"
                  @click="editMeasurement(props.item)"
              >
                {{ 'app.show_and_edit' | trans }}
              </icon-button>
              <icon-button
                  :permission="hasPermission('patient_measurements_delete')"
                  icon="delete"
                  color="red"
                  cls="mr-0 ml-0"
                  :tooltip="{top: true, bottom: false, attach: false}"
                  :iconOptions="{small: true}"
                  @click="deleteMeasurement(props.item)"
              >
                {{ 'app.delete' | trans }}
              </icon-button>
            </v-layout>
          </td>
        </tr>
      </template>

    </v-data-table>
  </div>
</template>
<script>
import {trans} from "../../app";
import MeasurementService from "../../services/MeasurementService";
import goTo from "vuetify/lib/components/Vuetify/goTo";
import {mapGetters, mapActions} from "vuex";

export default {
  data: function () {
    return {
      items: [],
      headers: [
        {
          text: trans('app.measurements.weight'), align: 'left', value: 'weight', sortable: false,
        },
        {
          text: trans('app.measurements.neck'), align: 'left', value: 'neck', sortable: false,
        },
        {
          text: trans('app.measurements.arm'), align: 'left', value: 'arm', sortable: false,
        },
        {
          text: trans('app.measurements.chest'), align: 'left', value: 'chest', sortable: false,
        },
        {
          text: trans('app.measurements.waist'), align: 'left', value: 'waist', sortable: false,
        },
        {
          text: trans('app.measurements.stomach'), align: 'left', value: 'stomach', sortable: false,
        },
        {
          text: trans('app.measurements.hips'), align: 'left', value: 'hips', sortable: false,
        },
        {
          text: trans('app.measurements.thigh'), align: 'left', value: 'thigh', sortable: false,
        },
        {
          text: trans('app.measurements.calf'), align: 'left', value: 'calf', sortable: false,
        },
        {
          text: trans('app.date'), align: 'center', value: 'created_at', sortable: true,
        },
        {
          text: '', align: 'center', sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 50,
        sortBy: 'created_at',
        descending: true,
      },
      total: 0,
      isLoading: true,
      measurementService: null,
    };
  },
  props: {
    patient_id: {
      type: Number,
    }
  },
  created() {
    this.measurementService = new MeasurementService();
    this.triggerFetchMeasurement();
  },
  methods: {
    ...mapActions(['fetchMeasurements']),
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
      };

      await this.triggerFetchMeasurement(query);

      this.isLoading = false;
    },
    deleteMeasurement(measurement) {
      this.$confirmDanger(
          trans('app.measurements.confirm_removal'),
          trans('app.measurements.confirm_removal_title')
      ).then(async () => {
        goTo(0, {
          duration: 1000
        });
        this.isLoading = true;
        await this.measurementService.deleteMeasurement(this.patient_id, measurement.id);
        this.$toast(trans('app.actions.removed', {name: trans('app.measurement').toLowerCase()}));
        await this.fetchMeasurements({patientId: this.patient_id});
        this.isLoading = false;
        this.$root.$emit('measurementDeleted');
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
    async triggerFetchMeasurement(query) {
      await this.fetchMeasurements({
        patientId: this.patient_id,
        params: query || this.pagination,
      });
      this.total = this.measurements.total;
      this.pages = this.measurements.last_page;
    },
    editMeasurement(measurement) {
      this.$emit('edit-measurement', Object.assign({}, measurement));
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['measurements', 'hasPermission']),
  }
}
</script>
